// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Cameroon from '../_raw/flag/icon_flag_cameroon.png';

export default () => <img src={Cameroon} alt="Cameroon" />;
